import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, ButtonBase } from '@mui/material';

// project imports
import LogoSection from '../../components/LogoSection';
import ProfileSection from '../../components/ProfileSection';

// assets
import { IconMenu2 } from '@tabler/icons';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const CommonHeader = ({ handleLeftDrawerToggle }) => {
    const theme = useTheme();

    return (
        <>
            
            {/* logo & toggler button */} 
            <Box
                sx={{
                    width: 228,
                    display: 'flex',
                    [theme.breakpoints.down('md')]: {
                        width: 'auto'
                    },
                }}
            >
                <Box component="span" sx={{ display: { xs: 'none', md: 'flex' }, flex: 1, alignItems:'center', marginRight: 5}}>
                    <LogoSection />
                </Box>
                <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden'  }}>
                    <Avatar
                        variant="rounded"
                        sx={{
                            ...theme.typography.commonAvatar,
                            ...theme.typography.mediumAvatar,
                            transition: 'all .2s ease-in-out',
                            background: theme.palette.background.paper,
                            color: theme.palette.secondary.dark,
                            '&:hover': {
                                background: theme.palette.secondary.dark,
                                color: theme.palette.secondary.light
                            }
                        }}
                        onClick={handleLeftDrawerToggle}
                        color="inherit"
                    >
                        <IconMenu2 stroke={1.5} size="1.3rem" color='#f77307' />
                    </Avatar>
                </ButtonBase>
            </Box>
            
            <Box sx={{ flexGrow: 1 }} />
            <ProfileSection />
        </>
    );
};

CommonHeader.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default CommonHeader;